import { Card, CardBody, CardHeader, Badge, ConfidenceBadge } from "@odingard/design-system";
import { EmptyState, ErrorState, LoadingState } from "@odingard/design-system";
import { useAuth } from "../../lib/auth";
import { useAsync } from "../../lib/useAsync";
import { proposalApi } from "../../lib/api";
import { DemoModeBanner } from "../../components/ProposalGrounded";

// ROI/analytics records always expose their calculation method and the source
// record set, so no number is presented without a traceable derivation.
export function PaiAnalytics() {
  const { activeOrg } = useAuth();
  const orgId = activeOrg?.id ?? "";
  const state = useAsync(async () => proposalApi.roi(orgId), [orgId]);

  return (
    <>
      <div className="page-head">
        <div>
          <h1>Analytics</h1>
          <p>ROI and pipeline metrics with transparent calculation methods.</p>
        </div>
      </div>

      <DemoModeBanner show={state.data?.demoMode ?? false} />
      {state.loading && <LoadingState label="Loading analytics…" />}
      {state.error && <ErrorState description={state.error.message} onRetry={state.reload} />}
      {state.data && state.data.data.records.length === 0 && (
        <EmptyState title="No analytics yet" description="Metrics appear as you run pursuits through Proposal AI." />
      )}
      {state.data && state.data.data.records.length > 0 && (
        <div className="ods-stack">
          {state.data.data.records.map((r) => (
            <Card key={r.id}>
              <CardHeader title={r.metric} />
              <CardBody>
                <div className="ods-stack">
                  <div className="ods-row" style={{ justifyContent: "space-between" }}>
                    <span style={{ fontSize: "var(--ods-text-xl)", fontWeight: 700 }}>{r.value}</span>
                    <ConfidenceBadge value={r.confidence} />
                  </div>
                  <p style={{ margin: 0, color: "var(--ods-color-muted)", fontSize: "var(--ods-text-sm)" }}>
                    <strong>Method:</strong> {r.calculationMethod}
                  </p>
                  <p style={{ margin: 0, color: "var(--ods-color-muted)", fontSize: "var(--ods-text-sm)" }}>
                    <strong>Attribution:</strong> {r.attributionRules}
                  </p>
                  <div className="ods-row" style={{ flexWrap: "wrap", gap: "var(--ods-space-1)" }}>
                    <span style={{ fontSize: "var(--ods-text-sm)", color: "var(--ods-color-muted)" }}>Sources:</span>
                    {r.sourceRecordIds.map((s) => (
                      <Badge key={s} tone="neutral">{s}</Badge>
                    ))}
                  </div>
                  <span style={{ fontSize: "var(--ods-text-sm)", color: "var(--ods-color-muted)" }}>
                    Range {r.timeRange.start} → {r.timeRange.end}
                  </span>
                </div>
              </CardBody>
            </Card>
          ))}
        </div>
      )}
    </>
  );
}
